module.exports = __webpack_public_path__ + "static/media/NFO.15bf1e62.svg";